import { Text } from '@/components/atoms/Text';

type NavPillProps = {
  children: React.ReactNode;
};

export function NavPill({ children }: NavPillProps) {
  return (
    <span className='inline-block rounded-sm border border-gray-dark-600 bg-gray-dark-800 px-4 py-1 uppercase'>
      <Text
        variant='body-s'
        color='gray-dark-400'
        classNames={{ wrapper: 'font-serif tracking-wider' }}
      >
        {children}
      </Text>
    </span>
  );
}
